<app-navbar></app-navbar>


<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">


      <!-- <app-lab-sidebar></app-lab-sidebar> -->

      <div class="card shadow m-3" style="width: 100%">

        <div class="card-header heading_n_button_box">
          <div class="card-heading">
            <h4>Laboratory User Activities</h4>
          </div>
        </div>


        <div class="card-body">

          <div class="col-lg-12 ">

            <div class="">

              <form [formGroup]="searchForm" (ngSubmit)="onSubmitSearch(searchForm.value)">
                <div class="row">
                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                    <input name="activity_name" formControlName="activity_name" id="activity_name" type="text"
                      class="form-control col-lg-12" placeholder="Enter Name">
                  </div>

                  <!-- <div class="col">
                          <input name="user_email" formControlName="user_email" id="user_email" type="text"
                            class="form-control col-lg-12" placeholder="Enter User Email">
                        </div>
      
      
                        <div class="col">
                          <input name="user_phone" formControlName="user_phone" id="user_phone" type="text"
                            class="form-control col-lg-12" placeholder="Enter User Phone">
                        </div> -->


                  <div class="col-lg-9  col-sm-6  col-md-6  mt-320_view">
                    <div class="mr-4">
                      <button type="submit" class="btn btn-secondary  theme-btn-2 dropdown-toggle-no"
                        id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-search"></i> Search
                      </button>


                      <button class="btn btn-secondary  theme-btn-2 dropdown-toggle-no ml-2" type="button"
                        id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false" (click)="clearSearch()">
                        <i class="fas fa-sync-alt"></i> Clear
                      </button>

                    </div>
                  </div>
                </div>
              </form>

            </div>


            <div class="">
              <div class="table-responsive mt-3">

                <div class="col-auto">
                  <div class="row" *ngIf="usersActivities">
                    <div class="show-record mt-3 mbm-32">
                      <span>Show</span> &nbsp;
                      <select class="custom-select custom-select-sm form-control form-control-sm"
                        (change)="setItemsPerPage(page.value)" #page>
                        <option [selected]="currentPageLength==10">10</option>
                        <option [selected]="currentPageLength==30">30</option>
                        <option [selected]="currentPageLength==50">50</option>
                        <option [selected]="currentPageLength==100">100</option>
                        <option [selected]="currentPageLength==500">500</option>
                        <option [selected]="currentPageLength==1000">1000</option>
                      </select> &nbsp;
                      <span> entries</span>
                    </div>
                  </div>
                </div>

                <table *ngIf="usersActivities"
                  class="table table-bordered table-condensed table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl"
                  datatable [dtOptions]="dtOptions" width="100%">
                  <thead class="">
                    <tr>
                      <th>S/N</th>
                      <th>Name</th>
                      <th>Role</th>
                      <th>Action taken</th>
                      <th>Created At</th>
                    </tr>
                  </thead>
                  <tbody class="dashboard-bg-white">
                    <tr *ngFor="let activity of usersActivities | paginate: config; index as i">
                      <td>{{config.itemsPerPage * (config.currentPage - 1) + i + 1}}</td>
                      <td>{{activity.name}}</td>
                      <td>{{activity.display_name}}</td>
                      <td>{{activity.title}}</td>
                      <td>{{activity.created_at | date: 'medium'}}</td>
                    </tr>

                  </tbody>
                </table>

                <div class="table-footer">
                  <div id="page_info" class="mt-3 record-show-text-bottom" *ngIf="usersActivities">
                    Showing {{(config.currentPage-1) * config.itemsPerPage + 1}} - {{config.currentPage *
                    config.itemsPerPage}}
                    of {{ config.totalItems }} entries
                  </div>

                  <div class="pagination paging-pull-right" *ngIf="usersActivities">
                    <pagination-controls (pageChange)="pageChange($event)" class="my-pagination mt-2 pagination-server">
                    </pagination-controls>
                  </div>
                </div>


              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>


  <app-footer-dashboard></app-footer-dashboard>